import styled from 'styled-components'

export const ContainerOfModal = styled.div<{width?: string}>`
  background-color: #fff;
  width: ${({width}) => width || '600px'};
  border-radius: 1rem;
  padding: 1.5rem;
  max-height: 80%;
  overflow-y: auto;
`

export const ViewContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 1rem;
`

export const ViewItem = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  span{
    font-size: 15px;
    font-weight: 400;
  }
`

export const FormContainer = styled.form<{columns?: string}>`
  display: grid;
  grid-template-columns: ${({columns}) => columns || '1fr'};
  gap: 1rem;
`

export const InputDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: .3rem;
`

export const Label = styled.label`
  font-size: 15px;
  font-weight: 700;
`

export const Input = styled.input`
  width: 100%;
  border: none;
  outline: none;
  background-color: #EBEBEB;
  height: 2.98rem;
  padding: 0 1rem;
  border-radius: 2rem;
  font-size: 15px;
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
`

export const HeaderTitle = styled.h2`

`

export const CloseDiv = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;

  &:hover{
    background-color: #F4F4F4;
  }
`


export const BottomDiv = styled.div`
  margin-top: 1rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  gap:1.5rem;
  span{
    color:red;
  }
`

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  gap: 1rem;
  position: sticky;
  bottom: 0;
  background-color: #fff;
  margin-top: 1.5rem;
  grid-column: 1 / -1;
`

export const Button = styled.button`
  background-color: #0090D3;
  color: #fff;
  padding: .7rem 1.2rem;
  font-weight: 700;
  font-size: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap:.5rem;
  border-radius: 1.5rem;
  user-select: none;
  cursor: pointer;
  border: none;
  outline: none;
  img{
    width: 1rem;
  }
  &.cancel{
    border: 1px solid #0090D3;
    color: #0090D3;
    background-color: #fff;
  }
`